<script>
import Japan from "@/components/flags/Japan";
import UnitedStates from "@/components/flags/UnitedStates";

export default {
  name: "Nav",
  components: {
    Japan,
    UnitedStates
  },
  methods: {
    toggleLanguage() {
      let newLocale = "en";

      if (this.$i18n.locale === "en") {
        newLocale = "jp";
      }

      this.$router.replace({
        name: this.$route.name,
        params: {
          lang: newLocale
        }
      });
    }
  },
  computed: {
    workUrl() {
      return `/${this.$route.params.lang}/work`;
    },
    aboutUrl() {
      return `/${this.$route.params.lang}/about`;
    },
    homeUrl() {
      return `/${this.$route.params.lang}`;
    }
  }
};
</script>

<template>
  <div class="nav">
    <router-link
      class="logo"
      :to="homeUrl"
      active-class=""
      exact-active-class=""
      >K. Mai Ho</router-link
    >
    <div class="links">
      <router-link class="text-link" :to="workUrl">{{
        $t("nav.work")
      }}</router-link>
      <router-link class="text-link" :to="aboutUrl">{{
        $t("nav.about")
      }}</router-link>
      <div class="flag" @click="toggleLanguage">
        <Japan v-if="this.$i18n.locale === 'en'" />
        <united-states v-else />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.nav {
  display: flex;
  font-family: "Poppins";
  font-style: normal;
  background-color: var(--main-bg-color);
  color: black;
  padding-top: 21px;
  padding-bottom: 16px;
  margin: 0 auto;
  margin-bottom: 70px;
  max-width: 860px;
  vertical-align: middle;

  .logo {
    color: var(--primary-color);
    text-decoration: none;
    font-weight: 600;
    font-size: 18px;
  }

  .links {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    margin-right: 34px;

    .text-link {
      position: relative;
      display: inline-flex;
      margin-left: 31px;
      margin-right: 31px;
      color: var(--nav-link-color);
      text-decoration: none;
    }
  }

  .flag {
    cursor: pointer;
    margin-left: 5px;
  }
}
</style>
